/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const LinkBadge16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M8 0a8 8 0 110 16A8 8 0 018 0zm0 1a7 7 0 100 14A7 7 0 008 1zM5.935 6.952a.5.5 0 01.067.637l-.057.07-.583.6c-.65.67-.65 1.765 0 2.435a1.605 1.605 0 002.204.11l.118-.11.583-.601a.5.5 0 01.774.626l-.057.07-.583.601a2.606 2.606 0 01-3.757 0 2.764 2.764 0 01-.128-3.685l.128-.142.584-.6a.5.5 0 01.707-.011zm5.42-2.342a2.764 2.764 0 01.129 3.685l-.128.142-.584.6a.5.5 0 01-.774-.626l.057-.07.583-.6c.65-.67.65-1.765 0-2.435a1.605 1.605 0 00-2.204-.11l-.118.11-.583.601a.5.5 0 01-.774-.626l.057-.07.583-.601a2.606 2.606 0 013.757 0zm-2.5 2.536a.5.5 0 01.057.638l-.057.07-1 1a.5.5 0 01-.765-.638l.057-.07 1-1a.5.5 0 01.708 0z"
        />
    </AccessibleSVG>
);

export default LinkBadge16;
